"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var NewLocation = function NewLocation() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "16",
    height: "20",
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.00165 9.86535C8.49924 9.86535 8.92463 9.68818 9.27783 9.33385C9.63103 8.97952 9.80763 8.55356\n9.80763 8.05598C9.80763 7.55839 9.63046 7.133 9.27613 6.7798C8.9218 6.4266 8.49584 6.25 7.99825\n6.25C7.50067 6.25 7.07528 6.42717 6.72208 6.7815C6.36888 7.13583 6.19228 7.56179 6.19228\n8.05938C6.19228 8.55696 6.36945 8.98235 6.72378 9.33555C7.07811 9.68875 7.50407 9.86535 8.00165\n9.86535ZM7.99995 17.5135C9.95635 15.7622 11.4535 14.0824 12.4913 12.474C13.5291 10.8657 14.048\n9.45703 14.048 8.24805C14.048 6.42498 13.4689 4.92627 12.3105 3.7519C11.1522 2.57753 9.71534\n1.99035 7.99995 1.99035C6.28457 1.99035 4.84771 2.57753 3.68938 3.7519C2.53105 4.92627 1.95188\n6.42498 1.95188 8.24805C1.95188 9.45703 2.47079 10.8657 3.5086 12.474C4.54644 14.0824 6.04355\n15.7622 7.99995 17.5135ZM7.99995 19.5096C5.4833 17.3288 3.59613 15.2993 2.33843 13.4211C1.08075\n11.5429 0.451904 9.81857 0.451904 8.24805C0.451904 5.94038 1.19838 4.07213 2.69133 2.64328C4.18426\n1.21443 5.9538 0.5 7.99995 0.5C10.0461 0.5 11.8156 1.21443 13.3086 2.64328C14.8015 4.07213 15.548\n5.94038 15.548 8.24805C15.548 9.81857 14.9192 11.5429 13.6615 13.4211C12.4038 15.2993 10.5166\n17.3288 7.99995 19.5096Z",
    fill: "#6E6D71"
  }));
};
var _default = NewLocation;
exports.default = _default;